
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { verifyPayment } from '../services/paymentService';
import { getCurrentUser } from '../services/authService';
import { useAuth } from '../context/AuthContext';

const PaymentVerify = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();
    const { login } = useAuth();
    const reference = searchParams.get('reference');

    useEffect(() => {
        const verify = async () => {
            if (!reference) {
                setStatus('error');
                setMessage('Invalid payment reference!');
                return;
            }
            try {
                await verifyPayment(reference);

                // Refresh user data so frontend knows plan is updated
                const updatedUser = await getCurrentUser();
                login(updatedUser);

                setStatus('success');
                setMessage('Your plan has been upgraded successfully!');
                setTimeout(() => navigate('/dashboard'), 3000);
            } catch (err: any) {
                setStatus('error');
                setMessage(err.response?.data?.message || 'Payment verification failed!');
            }
        };
        verify();
    }, [reference, navigate, login]);

    return (
        <div className="min-h-screen bg-gray-900 flex items-center justify-center px-6">
            <div className="w-full max-w-md text-center">
                {status === 'loading' && (
                    <div>
                        <div className="animate-spin text-6xl mb-6">⚡</div>
                        <h2 className="text-2xl font-bold text-white mb-2">
                            Verifying Payment...
                        </h2>
                        <p className="text-gray-400">Please wait while we confirm your payment!</p>
                    </div>
                )}

                {status === 'success' && (
                    <div>
                        <p className="text-6xl mb-6">🎉</p>
                        <h2 className="text-2xl font-bold text-white mb-2">
                            Payment Successful!
                        </h2>
                        <p className="text-gray-400 mb-4">{message}</p>
                        <p className="text-purple-400 text-sm">
                            Redirecting to dashboard in 3 seconds...
                        </p>
                    </div>
                )}

                {status === 'error' && (
                    <div>
                        <p className="text-6xl mb-6">❌</p>
                        <h2 className="text-2xl font-bold text-white mb-2">
                            Payment Failed!
                        </h2>
                        <p className="text-gray-400 mb-6">{message}</p>
                        <button
                            onClick={() => navigate('/pricing')}
                            className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-3 rounded-xl font-semibold transition">
                            Try Again
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PaymentVerify;


